import React from 'react';
import { Confirm, Header, Icon, Popup, Table } from 'semantic-ui-react';
import { Asesor, Asignacion } from '../tipos';
import ModalAtencion from './ModalAtencion';

interface Props {
    asesores: Array<Asesor>;
    asignaciones: Array<Asignacion>;
    alAsignar(datos: { idAsesor: string; idPersona: string }): void;
    alEliminar(id: string): void;
}

interface State {
    personaAAtender?: Asignacion;
    personaAEliminar?: Asignacion;
}

class TablaDeAsignaciones extends React.PureComponent<Props, State> {
    public state: State = {
        personaAAtender: undefined,
        personaAEliminar: undefined,
    };

    public render() {
        const { asignaciones } = this.props;
        return (
            <div>
                <Header as='h2'>Personas esperando atención</Header>

                {!!this.state.personaAAtender && this.modalConfirmarAtencion()}
                {this.state.personaAEliminar && this.modalEliminarPersona()}

                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell content='Nombre' />
                            <Table.HeaderCell content='Rut' />
                            <Table.HeaderCell content='Hora de llegada' />
                            <Table.HeaderCell content='Área' />
                            <Table.HeaderCell content='Medio de información' />
                            <Table.HeaderCell content='Asesor' />
                            <Table.HeaderCell />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {asignaciones.map(asignacion => (
                            <Fila
                                key={asignacion.idPersona}
                                {...asignacion}
                                alPresionarTicket={() =>
                                    this.setState({ personaAAtender: asignacion })
                                }
                                alPresionarCruz={() =>
                                    this.setState({ personaAEliminar: asignacion })
                                }
                            />
                        ))}
                    </Table.Body>
                </Table>
            </div>
        );
    }

    private modalEliminarPersona(): React.ReactNode {
        return (
            <Confirm
                open
                size='mini'
                dimmer='blurring'
                content='¿Está seguro que quiere eliminar esta persona?'
                confirmButton='Sí'
                cancelButton='No'
                onConfirm={() => {
                    this.props.alEliminar(this.state.personaAEliminar!.idPersona);
                    this.setState({ personaAEliminar: undefined });
                }}
                onCancel={() => this.setState({ personaAEliminar: undefined })}
            />
        );
    }

    private modalConfirmarAtencion(): React.ReactNode {
        return (
            <ModalAtencion
                nombrePersona={this.state.personaAAtender!.nombre}
                asesores={this.props.asesores}
                idAsesorPredeterminado={
                    this.props.asignaciones.length > 0 ? this.props.asignaciones[0].asesor.id : ''
                }
                alConfirmar={({ idAsesor }) => {
                    this.props.alAsignar({
                        idPersona: this.state.personaAAtender!.idPersona,
                        idAsesor,
                    });
                }}
                alCancelar={() => this.setState({ personaAAtender: undefined })}
            />
        );
    }
}

class Fila extends React.Component<
    Asignacion & { alPresionarTicket(): void; alPresionarCruz(): void },
    { encima: boolean }
> {
    public state = { encima: false };

    public render() {
        const visible = this.state.encima;

        const iconoStyle = { visibility: visible ? 'initial' : 'hidden' };

        return (
            <Table.Row
                onMouseOver={() =>
                    this.setState({
                        encima: true,
                    })
                }
                onMouseLeave={() => this.setState({ encima: false })}
            >
                <Table.Cell content={this.props.nombre} />
                <Table.Cell content={this.props.rutOPasaporte} />
                <Table.Cell content={this.props.horaDeLlegada} />
                <Table.Cell content={this.props.areaDeInteres} />
                <Table.Cell content={this.props.medioDeInformacion} />
                <Table.Cell content={this.props.asesor.nombre} />
                <Table.Cell textAlign='right'>
                    <Popup
                        trigger={
                            <Icon
                                circular
                                link
                                name='check'
                                style={iconoStyle}
                                onClick={this.props.alPresionarTicket}
                            />
                        }
                        content='Atender'
                        inverted
                    />
                    <Popup
                        trigger={
                            <Icon
                                circular
                                link
                                name='close'
                                style={iconoStyle}
                                onClick={this.props.alPresionarCruz}
                            />
                        }
                        content='Eliminar'
                        inverted
                    />
                </Table.Cell>
            </Table.Row>
        );
    }
}

export default TablaDeAsignaciones;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/TurnosYAtenciones/componentes/TablaDeAsignaciones.tsx